export const storagePath = process.env.REACT_APP_STORAGE_URL + '/';